import {RequestTrackerService} from "../../../Component/Api/Staging/RequestTrackerService";
import {SaveCsvFile} from "../../../Component/Model/helpers";

export type StagedImportFileSection = 'people' | 'salaries';

export const DownloadStagedImportFile = async (requestId: number, section: StagedImportFileSection) => {
    const request = section === 'people'
        ? RequestTrackerService.downloadPeopleImportFile(requestId)
        : RequestTrackerService.downloadSalaryImportFile(requestId);

    const result = await request.catch(() => undefined);
    if (result) {
        SaveCsvFile(result.data, `payroll-request-${requestId}-${section}.csv`);
    }
}
